export default __webpack_public_path__ + "static/studionft-2-2caa13b09c7b927e7b426cb63e54e03a.jpg";